import { AccountCircle, Face, LogoutOutlined, Person } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLogin } from "../../../context/Login/LoginContext";
import LoginDialog from "../../Login/LoginDialog";
import PopupMenu from "../../PopupMenu/PopupMenu";
import { HeaderIconButton } from "./Components";
import { alpha } from "@mui/system";

const LoginButton = () => {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const { isLoggedIn, logout, user } = useLogin();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    useEffect(() => {
        setAnchorEl(null);
        setOpen(false);
    }, [isLoggedIn]);

    if (isLoggedIn)
        return (
            <>
                <HeaderIconButton
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                    onContextMenu={(e) => {
                        e.preventDefault();
                        setAnchorEl(e.currentTarget)
                    }}
                >
                    {user?.image ? (
                        <img
                            src={user.image}
                            alt="Profile"
                            style={{
                                width: 32,
                                height: 32,
                                borderRadius: '50%',
                                objectFit: 'cover',
                                border: '2px solid #ccc',
                                // boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.1)'
                            }}
                        />
                    ) : (
                        <Face sx={{ fontSize: 32, p: 0, border: theme => `2px solid ${alpha(theme.palette.text.primary, 0.6)}`, borderRadius: '100%' }} />
                    )}
                </HeaderIconButton>
                <PopupMenu
                    anchorEl={anchorEl}
                    onClose={() => setAnchorEl(null)}
                    options={[
                        { label: 'Profile', onClick: () => navigate('/profile'), icon: <Person /> },
                        { label: 'Logout', onClick: () => logout(), icon: <LogoutOutlined /> },
                    ]}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    offsetY={1}
                />
            </>
        )

    return (
        <>
            <HeaderIconButton onClick={() => setOpen(true)}>
                <AccountCircle />
            </HeaderIconButton>
            <LoginDialog open={open} onClose={() => setOpen(false)} />
        </>
    )
}


export default LoginButton;